import { navigateToHeydayPage, subscribeToHeydayLocation } from '../../config/heydayRoutes';
import type { EmployeeDirectoryRoutePort } from '../../features/people/public';

export const employeeDirectoryRouteAdapter: EmployeeDirectoryRoutePort = {
  read() {
    const parameters = new URLSearchParams(window.location.search);
    const workerId = parameters.get('worker')?.trim() || undefined;
    const organizationId = workerId ? undefined : parameters.get('organization')?.trim() || undefined;
    return {
      view: parameters.get('view') === 'chart' || organizationId ? 'chart' : 'directory',
      search: parameters.get('search')?.trim() ? parameters.get('search')! : undefined,
      workerId,
      organizationId,
    };
  },
  replace(state) {
    const parameters = new URLSearchParams();
    if (state.view === 'chart') parameters.set('view', 'chart');
    if (state.search) parameters.set('search', state.search);
    if (state.workerId) parameters.set('worker', state.workerId);
    else if (state.organizationId) parameters.set('organization', state.organizationId);
    navigateToHeydayPage('directory', parameters, { replace: true });
  },
  subscribe: subscribeToHeydayLocation,
};
